export const TEST_ID = 'tabPanelHealth';
